import filters from '@/services/Filters'

export default {
  install(app) {
    const { currency, float } = filters
    app.config.globalProperties.currency = currency
    app.config.globalProperties.float = float
  }
}
